module.exports = __webpack_public_path__ + "assets/mobile-tina.7f8e2b1d.png";